(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodTimeSlotPicker', sodTimeSlotPicker);

    function sodTimeSlotPicker(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                render: '=?'
            },
            templateUrl: 'common/components/sod-time-slot-picker',
            link: function(scope, elem, attr, ctrl) {
                var formatDisplay = lodash.get(scope.options, 'datepicker.format_display', 'D MMM YYYY');
                var formatValue = lodash.get(scope.options, 'datepicker.format_value', 'YYYY-M-D');

                if (!scope.options) {
                    scope.options = {};
                }
                scope.testCtrl = ctrl;
                var fields = {
                    start_date: lodash.get(scope.options, 'field.start_date', 'start_date'),
                    start_time: lodash.get(scope.options, 'field.start_time', 'start_time'),
                    end_date: lodash.get(scope.options, 'field.end_date', 'end_date'),
                    end_time: lodash.get(scope.options, 'field.end_time', 'end_time'),
                    time_zone: lodash.get(scope.options, 'field.time_zone', 'time_zone'),
                };
                
                var time_slot_picker_dom = elem.find('.sod-time-slot-picker'),
                    // time_picker_dom = elem.find('.sod-time-slot-picker .time'),
                    start_date_picker_dom = elem.find('.sod-time-slot-picker .date.start'),
                    end_date_picker_dom = elem.find('.sod-time-slot-picker .date.end'),
                    start_time_picker_dom = elem.find('.sod-time-slot-picker .time.start'),
                    end_time_picker_dom = elem.find('.sod-time-slot-picker .time.end')
                ;

                ctrl.$formatters.push(function(modelValue) {
                    return {
                        start_date: lodash.get(modelValue, fields.start_date, ''),
                        start_time: lodash.get(modelValue, fields.start_time, ''),
                        end_date: lodash.get(modelValue, fields.end_date, ''),
                        end_time: lodash.get(modelValue, fields.end_time, ''),
                        time_zone: lodash.get(modelValue, fields.time_zone, ''),
                    };
                });

                // ctrl.$viewChangeListeners.push(function() {
                //     setValueFromExternal();
                // });

                scope.setValue = setValueFromExternal;
                scope.render = function() {
                    ctrl.$render();
                };

                scope.$watch('start_date + start_time + end_date + end_time + time_zone', function() {
                   setValue();
                });
                // scope.$watch(function() {
                //     return ctrl.$modelValue;
                // }, function() {
                //    console.log(ctrl.$modelValue);
                // });

                ctrl.$render = function() {
                    setValueFromExternal();
                };

                ctrl.$parsers.push(function(viewValue) {
                    viewValue.start_date = moment(viewValue.start_date, formatDisplay).format(formatValue);
                    viewValue.end_date = moment(viewValue.end_date, formatDisplay).format(formatValue);
                    return viewValue;
                });


                initPickers();

                function setValueFromExternal() {
                    var start_date = moment(ctrl.$viewValue.start_date, formatValue);
                    var end_date = moment(ctrl.$viewValue.end_date, formatValue);

	                  scope.start_date = start_date.isValid() ? start_date.format(formatDisplay) : "";
	                  scope.end_date = end_date.isValid() ? end_date.format(formatDisplay) : "";
                    scope.start_time = ctrl.$viewValue.start_time;
                    // scope.end_date = ctrl.$viewValue.end_date;
                    scope.end_time = ctrl.$viewValue.end_time;
                    scope.time_zone = ctrl.$viewValue.time_zone;
                }

                function setValue() {
                    ctrl.$setViewValue({
                        [fields.start_date]: scope.start_date,
                        [fields.start_time]: scope.start_time,
                        [fields.end_date]: scope.end_date,
                        [fields.end_time]: scope.end_time,
                        [fields.time_zone]: scope.time_zone,
                    });
                }

                function initPickers() {
                    var remote_dp_options = generateDatepickerOptions(lodash.get(scope.options, 'datepicker', {}));
                    var lang = angular.element('html').attr('lang');

                    var time_options = {
                        'showDuration': true,
                        'timeFormat': 'g:i a',
                        'disableTextInput': true,
                        'language': lang,
                        'step': lodash.get(scope.options, 'step', 15)
                        // 'minTime': '2:00pm',
                    };

                    var date_options = angular.merge(
                        {
                            'autoclose': true,
                            'orientation': 'auto bottom',
                            'language': lang,
                        },
                        remote_dp_options,
                        {
                            'format': {
                                toDisplay: function(date, format, language) {
                                    return moment(date, formatValue).format(formatDisplay);
                                },
                                toValue: function(date, format, language) {
                                    return moment(date, 'YYYY-M-D').format('D MMM YYYY');
                                }
                            }
                        }
                    );




                    start_time_picker_dom.timepicker(angular.merge(
                        time_options,
                        lodash.get(scope.options.timepicker, {})
                    ));
                    end_time_picker_dom.timepicker(angular.merge(
                        time_options,
                        lodash.get(scope.options.timepicker, {})
                    ));

                    start_date_picker_dom.datepicker(date_options)
                        .on('changeDate', function(e) {
                            // console.log('changeDate');
                            if (lodash.has(remote_dp_options, 'startDate')) {
                                // var start_date_moment = moment(e.date);
                                // var current_date_time = moment();
                                start_time_picker_dom.timepicker('option', 'minTime', null);
                                start_time_picker_dom.timepicker('option', 'maxTime', null);
                                /*if (start_date_moment.isSame(current_date_time, 'day')) {
                                    var min_time_str = current_date_time.startOf('hour').add(1,'hour').format('h:mma');
                                    var end_of_day_str = current_date_time.endOf('day').format('h:mma');
                                    start_time_picker_dom.timepicker('option', 'minTime', min_time_str);
                                    start_time_picker_dom.timepicker('option', 'maxTime', end_of_day_str);
                                } else {
                                    start_time_picker_dom.timepicker('option', 'minTime', null);
                                    start_time_picker_dom.timepicker('option', 'maxTime', null);
                                }*/
                            }
                        });
                    end_date_picker_dom.datepicker(date_options);

                    var currentDate = new Date();
                    // console.log(currentDate);

                    // initialize datepair
                    var datePairObj = new Datepair(time_slot_picker_dom[0], {
                        updateTime: function(input, dateObj){
                            var momentObj =  moment(dateObj);

                            if (angular.element(input).hasClass('time start')) {
                                scope.start_time = momentObj.format('h:mm a');
                                elem.find('.time.start').timepicker('setTime', scope.start_time);
                                input.value = momentObj.format('h:mm a');
                            } else {
                                scope.end_time = momentObj.format('h:mm a');
                                elem.find('.time.end').timepicker('setTime', scope.end_time);
                                input.value = momentObj.format('h:mm a');
                            }
                            // console.log(angular.element(input));
                            // scope.end_time = input.value;
                            scope.$apply();
                        },
                        setMinTime: new Date(),
                    });
                    // datePairObj.
                }

                function generateDatepickerOptions(dp_options) {
                    if (lodash.has(dp_options, 'startDate')) {
                        var dp_start_date = dp_options.startDate;
                        var start_date = new Date(dp_start_date.year, dp_start_date.month - 1, dp_start_date.day);
                        dp_options.startDate = start_date
                    }
                    return dp_options;
                }
            }
        };
    }
})();